<template>
  <div>

    <div class="flex-center-between">
      <div class="title">应用授权</div>
      <!-- <el-button type="primary" icon="el-icon-s-promotion" class="sign-button mr20 fz15"></el-button> -->
      <div>
        <el-button size="small" icon="el-icon-download" @click="downLoad">客户端应用</el-button>
        <el-button size="small" type="primary" @click="openAddVisible">添加授权</el-button>
      </div>
    </div>

<!--    <div class="flex mt35">-->
<!--    </div>-->

    <div class="pt10" v-for="(item,index) in authorizeList" v-loading="loading">
      <el-tabs type="border-card">
        <el-tab-pane>
          <div class="custom-item flex-center-between" >
            <div class="flex-center " style="width: 50%">
              <div class="title-name">Ukey序列号</div>
              <span >{{ item.ukeySn }}</span>
<!--              <el-link class="fz16" @click="copyText($store.state.account.user.name)">{{ $store.state.account.user.name }}</el-link>-->
            </div>
            <div>
<!--              <el-button class="fz16" type="text" @click="handleAuthorize()">授权</el-button>-->
            </div>
          </div>
          <div class="custom-item flex-center-between" >
            <div class="flex-center">
              <span class="title-name">应用密钥</span>
              <el-link class="fz16" @click="copyText(item.licKey)">{{ item.licKey }}</el-link>
            </div>
            <div>
              <el-button class="fz16" type="text" @click="copyText(item.licKey)">复制</el-button>
            </div>
          </div>
          <div class="custom-item flex-center-between" >
            <div class="flex-center">
              <span class="title-name">应用授权</span>
              <el-link class="fz16" @click="copyText(item.licData)">
                <div class="text-container">{{ item.licData }}</div>
              </el-link>
            </div>
            <div>
              <el-button class="fz16" type="text" @click="copyText(item.licData)">复制</el-button>
            </div>
          </div>
          <div class="custom-item flex-center-between" >
            <div class="flex-center">
              <span class="title-name">授权有效期至</span>
              <span >{{ item.notAfter }}</span>
<!--              <el-link class="fz16" @click="copyText($store.state.account.user.code)">{{ $store.state.account.user.code }}</el-link>-->
            </div>
            <div>
              <el-button class="fz16" type="text" @click="handleExtension(item.ukeySn)">延期</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <add-dialog
      v-if="addVisible"
      :visible.sync="addVisible"
      @getApplyESeal="getApplyESeal"
    />

    <commodity-information
        v-if="commodityVisible"
        :visible.sync="commodityVisible"
        :ukeySn="ukeySn"
        :type="type"
        @updateDialog="getApplyESeal"
    />
  </div>
</template>

<script>

import AddDialog from "@/pages/userCenter/components/addDialog.vue";
import CommodityInformation from "@/pages/userCenter/components/commodityInformation.vue";

export default {
  name: "MyAuthorization",
  components: {CommodityInformation, AddDialog},
  data() {
    return {
      ukeySn: '',
      addVisible: false,
      commodityVisible: false,
      authorizeList: [],
      loading: false,
      type: 'edit'
    };
  },
  created() {
    this.getApplyESeal()
  },
  methods:{
    downLoad(){
      window.open('https://www.lngsyz.com/app/oes/client-oes.exe');
    },
    getApplyESeal(){
      this.loading = true
      this.$http.get(this.$api.user.getApplyESeal).then(res => {
        if (res.data.code == 200) {
          this.authorizeList = res.data.data
          this.loading = false
        }
      })
    },
    openAddVisible(){
      this.addVisible = true
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$message({
          message: '复制成功',
          type: 'success'
        });
      } catch (err) {
        console.error('复制失败', err);
      }
    },
    // 延期
    handleExtension(e){
      this.ukeySn = e
      this.commodityVisible = true
    },
    //
    updateDialog(){

    }
  }
}
</script>

<style lang="less" scoped>
.title-name {
  width: 125px;
}

.text-container {
  max-width: 250px; /* 或者其他需要的宽度 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title {
  border-top: 6px solid #407fff;
  width: 106px;
  font-weight: 400;
  font-size: 26px;
  color: #000;
  padding-top: 12px;
}

.custom-item {
  padding: 20px 15px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }

  ::v-deep .el-button {
    padding: 0 ;
  }
}

.lock-item {
  padding: 20px 15px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }

  .auth-label {
    background-color: #00cc69;
    border-radius: 9px 9px 9px 0;
    display: inline-block;
    font-weight: 300;
    color: #fff;
    font-style: normal;
    position: relative;
    padding: 0 5px;
    top: 0;
    font-size: 13px;
    margin-left: 20px;
  }

  .public-but {
    width: 60px;
    height: 24px;
    border: 1px solid #407fff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #407fff;
    line-height: 24px;
    text-align: center;
    margin: 0 0 0 25px;
    cursor: pointer;
    display: inline-block;
  }

  .public-warn {
    border: 1px solid #F56C6C;
    color: #F56C6C;
  }
}

::v-deep .el-tabs__item {
  height: 48px;
  line-height: 48px;
}

::v-deep .el-tabs__header {
  display: none
}

::v-deep .el-link--default {
  color: #2c3e50 ;
}
</style>
